import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=ec2fd536&scoped=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=ts"
export * from "./CustomCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./CustomCheckbox.vue?vue&type=style&index=0&id=ec2fd536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2fd536",
  null
  
)

export default component.exports